jQuery(function($){
  $(window).on('load', function(){
    var header_wrap = $('.header-wrapper'),
        header_wrap_par = header_wrap.parent();

    if ( header_wrap.hasClass('header_fixed') ) {
      header_wrap_par.removeClass('main_header_fixed');
    } else {
      header_wrap_par.addClass('main_header_fixed');
    }
  });

  var feat_col_slide = $('.feat_col_slide:not(.mob_center)');
  if ( feat_col_slide.length > 0 ) {
      var feat_slide = new Swiper('.feat_col_slide:not(.mob_center) .swiper-container', {
          slidesPerView: 1,
          spaceBetween: 15,
          pagination: {
            el: '.feat_col_slide:not(.mob_center) .pagination',
            clickable: true,
          },
          breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              1025: {
                slidesPerView: 3,
                spaceBetween: 90,
              }
          }
      });
  }

  // Homepage: centred mobile carousel with the side products peeking in
  $('.feat_col_slide.mob_center').each(function(){
    var root = this,
        wrapper = root.querySelector('.swiper-wrapper'),
        count = root.querySelectorAll('.swiper-slide').length,
        center = parseInt(root.getAttribute('data-center') || '0', 10) || 0,
        mid = Math.floor((count - 1) / 2),
        start = 0,
        pag = root.querySelector('.pagination'),
        arrows = root.querySelectorAll('.fc-arrow'),
        GAP = 40,   // space between products (the arrows sit in it)
        PEEK = 13;  // how much of the side products is visible on phones

    // On mobile / tablet, move the chosen product to the middle and open on it
    if (window.innerWidth <= 1024 && count > 1) {
      if (center > count - 1) { center = count - 1; }
      if (center !== mid) {
        var el = wrapper.children[center];
        wrapper.removeChild(el);
        wrapper.insertBefore(el, wrapper.children[mid] || null);
      }
      start = mid;
    }

    function phoneSpv(w) { return (w + GAP) / (w - 2 * (PEEK + GAP) + GAP); }

    // Keep the arrows vertically centred on the product photo
    function place(sw) {
      if (window.innerWidth > 1024 || !sw || !sw.slides || !sw.slides.length) return;
      var act = sw.slides[sw.activeIndex] || sw.slides[0],
          rr = root.getBoundingClientRect(),
          media = act.querySelector('.card__media, .media, img');
      if (media) {
        var ir = media.getBoundingClientRect(),
            top = (ir.top - rr.top) + ir.height / 2;
        for (var i = 0; i < arrows.length; i++) { arrows[i].style.top = top + 'px'; }
      }
    }

    function fitPhone(s) {
      if (window.innerWidth < 768 && s && s.width) {
        var spv = phoneSpv(s.width);
        if (Math.abs((s.params.slidesPerView || 0) - spv) > 0.001) {
          s.params.slidesPerView = spv;
          s.update();
          s.slideTo(s.activeIndex, 0, false);
        }
      }
    }

    var sw = new Swiper(root.querySelector('.swiper-container'), {
      slidesPerView: phoneSpv(root.clientWidth || window.innerWidth),
      spaceBetween: GAP,
      centeredSlides: true,
      initialSlide: start,
      pagination: {
        el: pag,
        clickable: true,
      },
      navigation: {
        prevEl: root.querySelector('.fc-arrow--prev'),
        nextEl: root.querySelector('.fc-arrow--next'),
      },
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 40,
          centeredSlides: true,
        },
        1025: {
          slidesPerView: 3,
          spaceBetween: 90,
          centeredSlides: false,
        }
      },
      on: {
        afterInit: function (s) { fitPhone(s); place(s); },
        slideChangeTransitionEnd: function (s) { place(s); },
        resize: function (s) { fitPhone(s); place(s); }
      }
    });
    place(sw);
    $(window).on('load', function(){ fitPhone(sw); place(sw); });
    root.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', function(){ place(sw); }); });
  });

  $(document).on('click', '#btn-create-another', function(x){
    x.preventDefault();

    window.location.replace("https://thecookiebox.com.au/collections/box-of-cookies");
  });

  var location = $('.location_slide');
  if ( location.length > 0 ) {
    var loc_slide = new Swiper('.location_slide .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 15,
      pagination: {
        el: '.location_slide .pagination',
        clickable: true,
      },
      breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 20,
          }
      }
    });
  }

  var monthly_slide = $('.montly-special .swiper-container');
  if ( monthly_slide.length > 0 ) {
    var monthly_slider = new Swiper('.montly-special .swiper-container', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      navigation: {
        nextEl: ".montly-special .next",
        prevEl: ".montly-special .prev",
      },
      allowTouchMove: false
    });
  }

  var cotm_slide = $('.cotm_section  .swiper-container');
  if ( cotm_slide.length > 0 ) {
    var cotm_slider = new Swiper('.cotm_section .swiper-container', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      // autoHeight: true,
      navigation: {
        nextEl: ".cotm_section .next",
        prevEl: ".cotm_section .prev",
      },
      allowTouchMove: false
    });
  }

  var delivery = $('.delivery_slider');
  if ( delivery.length > 0 ) {
    var del_slider = new Swiper('.delivery_slider .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 15,
      autoHeight: true,
      pagination: {
        el: '.delivery_slider .pagination',
        clickable: true,
      },
      breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 88
          }
      }
    });
  }

  var prod_tab = $('.prod_tabs'),
      prod_tab_title = prod_tab.find('.tab_title_item'),
      prod_tab_content = prod_tab.find('.tab_item');

  prod_tab_title.find('span').click(function(){
    var this_par = $(this).parent(),
        tab_target = this_par.data('tab'),
        target_elem = $('#' + tab_target);

    prod_tab_title.not(this_par).removeClass('active_title');
    prod_tab_content.not(target_elem).removeClass('active_content');

    this_par.addClass('active_title');
    target_elem.addClass('active_content');
  });

  
  $('a[href^="#"]').each(function() {
    // Add a class or modify the element to look like a button
    $(this).addClass('anchor-button');

    var sticky_header = $('sticky-header'),
        sticky_header_height = sticky_header.height();
      
    // Optionally, if you want to prevent the default behavior
    $(this).on('click', function(event) {
      event.preventDefault();
      // You can also add smooth scroll or other effects here
      const target = $(this).attr('href');
      if (target !== '#') {
        $('html, body').animate({
            scrollTop: $(target).offset().top - sticky_header_height
        }, 1000);
      }
    });
  });
});